(function () {
  'use strict';

  angular.module('sempraWebapp').directive('toGreaterThanFrom', function() {
    return {
      restrict: 'A',
      require: "ngModel",
      link: function(scope, element, attributes, ngModel) {

        ngModel.$parsers.push(function (value) {
          if(!value || value.length == 0) return;

          var otherValueString = scope.$eval(attributes.toGreaterThanFrom);

          ngModel.$setValidity('toGreaterThanFrom', true);

          if (value < new Date(otherValueString)) {
            ngModel.$setValidity('toGreaterThanFrom', false);
          }

          return value;
        });

      }
    };
  });
})();
